import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ContainerVm, ProgramVm, ResourceVm } from 'qp-ui-interface';
import { DataService } from '../../../data.service';
import { LocalStorageKeys } from '../../LocalStorageKeys';
import { NavigationLibraryService } from '../navigation/navigation.service';
import { ParentalControlDialogService } from '../parental-pin/parental-pin-dialog.service';
import { PlaybackService } from '../playback/playback.service';
import { ScreenService } from '../screen/screen.service';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable()
export class RoutingService {
  constructor(
    private readonly router: Router,
    private readonly dataService: DataService,
    private readonly navService: NavigationLibraryService,
    private readonly playbackService: PlaybackService,
    private readonly screenService: ScreenService,
    private readonly location: Location,
    private readonly parentalControlDialogService: ParentalControlDialogService,
    private localStorage: LocalStorageService
  ) {}

  async navigateToPlayerWithValidations(resource: ResourceVm, isContinueWatching: boolean, keepNavigationPos = false): Promise<boolean> {
    try {
      const allowAccess = await this.parentalControlDialogService.checkExplicitContent(resource);
      if (allowAccess) {
        this.dataService.isContinueWatching = isContinueWatching;
        return this.navigateDirectoToPlayer(resource);
      }
      const focusPosition = { verticalIndex: this.navService.getVerticalIndex(), horizontalIndex: this.navService.getHorizontalIndex() };
      if (keepNavigationPos) {
        this.navService.setVerticalIndex(focusPosition.verticalIndex);
        this.navService.setHorizontalIndex(focusPosition.horizontalIndex);
      }
      return Promise.resolve(false);
    } catch (e) {
      console.log('RoutingService.navigateToPlayer() error', e);
      return Promise.resolve(false);
    }
  }

  async navigateDirectoToPlayerFromChannelWithValidations(resource: ProgramVm): Promise<boolean> {
    try {
      const allowAccess = true; //await this.parentalControlDialogService.checkExplicitContent(channel);
      if (allowAccess) {
        return this.navigateDirectoToPlayerFromChannel(resource);
      }
      return Promise.resolve(false);
    } catch (e) {
      console.log('RoutingService.navigateDirectoToPlayerFromChannel() error', e);
      return Promise.resolve(false);
    }
  }

  async navigateDirectoToPlayer(resource: ResourceVm): Promise<boolean> {
    const { type, id: contentID } = resource;
    // set actual time to start time playback service
    this.setStartTime();
    return this.router.navigate([`player/${type}/${contentID}`], { state: { type, id: contentID, resource } });
  }

  async navigateDirectoToPlayerFromChannel(resource: ProgramVm): Promise<boolean> {
    const { channelId: contentID } = resource;
    const type = 'channel';
    // set actual time to start time playback service
    this.setStartTime();
    const focusPosition = { verticalIndex: this.navService.getVerticalIndex(), horizontalIndex: this.navService.getHorizontalIndex() };
    if (focusPosition.verticalIndex && focusPosition.horizontalIndex) {
      this.navService.setVerticalIndex(focusPosition.verticalIndex);
      this.navService.setHorizontalIndex(focusPosition.horizontalIndex);
    }
    return this.router.navigate([`player/${type}/${contentID}`], { state: { type, id: contentID, resource } });
  }

  async navigateToDetails(resource: ResourceVm, container?: ContainerVm): Promise<boolean> {
    const { type, id: contentID, collectionID, collectionName, uniqueId, contentType } = resource;
    if (contentType && uniqueId) {
      return this.router.navigate([`/${type}/${contentID}`], {
        state: { type, id: contentID, resource, container, collectionID, collectionName },
      });
    }
    return false;
  }

  navigateToLogin(source: string): void {
    this.router.navigate(['/on-boarding', 'login'], { queryParams: { source } });
    this.screenService.hideHero(); // force hide hero
  }

  navigateToPin(source: string, deeplink: boolean): Promise<boolean> {
    return this.router.navigate(['/on-boarding/pin'], {
      state: JSON.parse(this.localStorage.getItem(LocalStorageKeys.PROFILES)),
      queryParams: { source, skip: true, deeplink },
    });
  }

  async navigatePlayerUrl(backUrl: string) {
    if (backUrl === 'LOCATION_BACK') {
      this.location.back();
    } else {
      await this.router.navigateByUrl(backUrl);
    }
  }

  setStartTime(): void {
    this.playbackService.startTime = new Date().getTime();
    if (!this.dataService.playbackStartTime) {
      this.dataService.playbackStartTime = new Date().getTime();
    }
  }
}
